import { connect } from "react-redux";
import { validateFloat } from "../common/validation/Validators";
import Select from "react-select";
import _ from "lodash";
import {
	salaryPeriodOption,
	employmentTypeOption,
	paymentTypeOptions,
	weekdays,
	defaultWorking,
} from "./AgreementOptions";
import { TrashIcon } from "@heroicons/react/20/solid";

const FilterRow = ({ type, filters, updateField, removeField, selectedFilter, filterValue, secondaryValue, OptionsArray, appliedFilters }) => {
	return (
		<>
			<div className="col-xs-12">
				<div
					className="col-xs-3"
					style={{ padding: 0, marginBottom: 10 }}
				>
					<Select
						options={filters}
						value={filters?.find((f) => f?.value == selectedFilter?.value)}
						onChange={(e) => {
							updateField(
								"selectedFilter",
								OptionsArray?.find((o) => e?.value == o?.value),
							);
							updateField("value", null);
						}}
					/>
				</div>
				<div className="col-xs-1">
					<h2>=</h2>
				</div>
				<div
					className="col-xs-4"
					style={{ padding: 0, marginBottom: 10 }}
				>
					{selectedFilter?.type == "select" && (
						<Select
							options={selectedFilter?.options}
							value={selectedFilter?.options?.find((o) => filterValue == o?.value) || null}
							onChange={(e) => {
								updateField("value", e.value);
							}}
						/>
					)}
					{selectedFilter?.type == "number" && (
						<div>
							<div className='relative'>
								<input
									className={"full-width max-w-full"}
									value={filterValue}
									onChange={(e) => {
										updateField("value", validateFloat(e.target.value));
									}}
								/>
								{
									selectedFilter?.options && type == "change" ? (
										<div className="absolute inset-y-0 right-0 flex items-center">
										  <label htmlFor="currency" className="sr-only">
											Currency
										  </label>
											<Select
												options={selectedFilter?.options}
												value={selectedFilter?.options?.find((o) => secondaryValue == o?.value) || null}
												onChange={(e) => {
													updateField("secondaryValue", e.value);
												}}
											/>

										</div>
									) : ""
								}
							</div>
						</div>
					)}
					{selectedFilter?.type == "workingDays" && (
						<>
							{weekdays?.map((weekday, index) => (
								<div style={{ float: "left", marginTop: "0.75rem" }}>
									<label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b">
										<input
											className="working-days-check"
											type="checkbox"
											name={`workingDay${index + 1}]`}
											checked={filterValue?.includes(String(index + 1))}
											onClick={() => {
												let workingDays = filterValue;
												if (filterValue && filterValue.includes(String(index + 1)))
													filterValue = filterValue?.filter(
														(item) => item != String(index + 1),
													);
												else
													workingDays = _.sortedUniq([
														...(workingDays || []),
														String(index + 1),
													]);

												updateField("value", workingDays);
											}}
										/>
										<span></span>
										{weekday} &nbsp;
									</label>
								</div>
							))}
						</>
					)}
				</div>
				<div className="col-xs-1">
					<button
						className="btn btn-danger pull-left"
						type="button"
						style={{ float: "right", padding: 5, marginTop: "0.4rem" }}
						onClick={removeField}
					>
						<TrashIcon style={{ height: "1em", float: "left" }} />
					</button>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const gradeOptions = state?.grades?.gradeList?.map((item) => ({
		label: item.name,
		value: item.id,
	}));

	const allowanceList = [
		...(state.allowances?.allowanceList?.filter(
			(a) => !a.public || a.public == "no" || a.canBeRecurring == "yes" || a.canBeRecurring == true,
		) || []),
		...(state?.company?.settings?.allowances?.filter((allowance) => !allowance.temporary) || []),
	];

	const currency = state?.company?.settings?.currency || "€";

	//Create options that each filter can have
	const OptionsArray = [
		{ value: "salaryAmount", type: "number", options:
			[
				{ label: "%", value: "percentage" },
				{ label: currency, value: "amount" },
			]
		},
		{
			value: "payPeriodFrequency",
			type: "select",
			options: salaryPeriodOption,
		},
		{
			value: "net",
			type: "select",
			options: paymentTypeOptions,
		},
		{
			value: "employmentType",
			type: "select",
			options: employmentTypeOption,
		},
		{
			value: "grade",
			type: "select",
			options: gradeOptions,
		},
		{ value: "weeklyHours", type: "number" },
		{ value: "workingDays", type: "workingDays" },
		{ value: "previousHours", type: "number" },
	];

	allowanceList?.map((allowance, index) => {
		if (index > 7) return;
		OptionsArray.push({ value: `allowance-${allowance.id}`, type: "number", options:
			[
				{ label: "%", value: "percentage" },
				{ label: currency, value: "amount" },
			]
		});
	});

	return {
		OptionsArray,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FilterRow);
